import React from "react";

export default class CourseCollectionCard extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  render() {
    //console.log("CourseCollectionCard", this.props);

    return (
      <a
        href={this.props.path}
        className="course-collection-card"
        onClick={this.onClick}
      >
        <div className="wrapper">
          <div className="name">{this.props.name}</div>
          <div className="image">
            <img
              src={this.props.image_src}
              alt={"Stock image of " + this.props.name}
            />
          </div>
        </div>
      </a>
    );
  }

  onClick(e) {
    var tracker_id = $("#ga_tracker_id").val();

    if (typeof ga != "undefined" && tracker_id) {
      try {
        ga("create", tracker_id, "auto");
        ga(
          "send",
          "event",
          "Course Collection",
          "browseContent",
          this.props.name,
          { nonInteraction: false }
        );
      } catch (e) {
        //console.log('error with quiz GA', e);
      }
    } else {
      //console.log('ga is undefined')
    }
  }
}
